import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Municipios(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [municipios, setMunicipios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditarMunicipio(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaUsers/>
                    </button>
                </div>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Municipio', selector: row => row.munMunicipio, sortable: true, width: '25%'},
        { name: 'Id departamento', selector: row => row.munDepartamentoid, sortable: true, width: '25%'},
        { name: 'Departamento', selector: row => row.usrRolid, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.munActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchDepartamentos();
        fetchData(currentPage, perPage, searchTerm);
    }, []);
    const fetchData = async (page, rowsPerPage, filter) => {
        let url = `/parametros/municipios?page=${page}&limit=${rowsPerPage}&filter=${filter}`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setMunicipios(result.data);
        setTotalRows(result.meta.total);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchDepartamentos = async () => {
        let url = `/parametros/departamentosActivos`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDepartamentos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const handleFilter = (value) => {
        setSearchTerm(value);
        fetchData(currentPage, perPage, value);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage, searchTerm);
      };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage, searchTerm);
    };
    function EditarMunicipio (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('munMunicipio', row.munMunicipio);
        setValue('munDepartamentoid', row.munDepartamentoid);
        setValue('munActivo', row.munActivo);
    };
    const NuevoMunicipio = () =>  {
        setValue('id', 0);
        setValue('munMunicipio', '');
        setValue('munDepartamentoid', 0);
        setValue('munActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarmunicipio';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar municipio', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar municipio', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar municipio', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('munMunicipio', '');
        setValue('munDepartamentoid', 0);
        setValue('munActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Municipios</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Municipio</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario municipio</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='munMunicipio'>Municipio</label>
                                                <input id='munMunicipio' {...register('munMunicipio', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Municipio"/>
                                                {errors.munMunicipio && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='munDepartamentoid'>Departamento:</label>
                                            <select id='munDepartamentoid' {...register('munDepartamentoid', { required: true })} className='form-control' >
                                                {departamentos.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.id} {option.depDepartamento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.munDepartamentoid && <p style={{color: 'red'}}>Seleccione departamento</p>}
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('munActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button className='form-control' onClick={NuevoMunicipio}>Nuevo</button>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control' type="text" placeholder="Buscar" value={searchTerm} onChange={e => handleFilter(e.target.value)}/>        
                                    </div>
                                </div>
                                
                                
                                <DataTable
                                    title="Lista de municipios"
                                    columns={columns}
                                    data={municipios}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}